export default __webpack_public_path__ + "static/media/Jaguars.65705f60.png";